import { useEffect, useRef } from "react";
import { useMenu } from "./use-menu";

export const useHideSideNav = () => {
  const { isVisible, setIsVisible } = useMenu();
  const _cached = useRef(isVisible);

  useEffect(() => {
    setIsVisible(false);

    return () => {
      if (_cached.current) {
        setIsVisible(true);
      }
    };
  }, []);

  return null;
};
